import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MissionItem } from "./MissionItem";
import missionService from "../../services/missionService";
import { Pagination } from "../Pagination/Pagination";
export const Mission = ({ setRoute, droneId }) => {
    const { t } = useTranslation();
    const [missions, setMissions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 20;
    const [totalPages, setTotalPages] = useState(1);
    useEffect(() => {
        if (droneId) {
            missionService
                .getDroneMissions(droneId, currentPage, pageSize)
                .then((data) => {
                setMissions(data.items);
                setTotalPages(data.totalPageCount);
            });
        }
    }, [droneId]);
    const handlePageChange = (page) => {
        setCurrentPage(page);
        missionService.getDroneMissions(droneId, page, pageSize).then((data) => {
            setMissions(data.items);
            setTotalPages(data.totalPageCount);
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "mission-wrapper", children: [_jsxs("div", { children: [_jsx("div", { children: t("mission.table.missionStart") }), _jsx("div", { children: t("mission.table.missionEnd") }), _jsx("div", { children: t("mission.table.operator") }), _jsx("div", {}), _jsx("div", {})] }), missions.map((item, index) => {
                        return _jsx(MissionItem, { item: item, setRoute: setRoute }, index);
                    })] }), _jsx(Pagination, { currentPage: currentPage, totalPages: totalPages, onPageChange: handlePageChange })] }));
};
